import React, { CSSProperties } from "react";
import { Link, LinkProps } from "react-router-dom";
import classNames from "classnames";

import WaitingIndicator from "@general-ui/waiting-indicator/waiting-indicator";

import "./gradient-button.scss";

interface IGradientButtonProps {
	gradient?:
	"--gradient-sherbet"
	| "--gradient-sherbet-2"
	| "--gradient-sherbet-3"
	| "--gradient-seabreeze"
	| "--gradient-pina-colada"
	| "--gradient-sunset"
	| "--gradient-sunrise"
	| "--gradient-sunset-light"
	| "--gradient-watermelon"
	| "--gradient-blue-razz"
	| "--gradient-blue-razz-light";
	borderWidth?: string;
	borderStyle?: React.CSSProperties["borderStyle"];
	adminButton?: boolean;
	color?: React.CSSProperties["color"];
	width?: React.CSSProperties["width"];
	height?: React.CSSProperties["height"];
	opacity?: React.CSSProperties["opacity"];
	hoverOpacity?: React.CSSProperties["opacity"];
	margin?: React.CSSProperties["margin"];
	selected?: boolean;
	children?: React.ReactNode;
	wrapperClassNames?: string;
	buttonClassNames?: string;
	value?: string;
	alignment?: "left" | "center" | "right";
	loading?: boolean;
	buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
	linkProps?: LinkProps;
	fullBackgroundGradient?: boolean;
	asLink?: boolean;
	href?: string;
	inline?: boolean;
	wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
	defaultBackground?: string;
	unselectedHoverBackground?: string;
}

const GradientButton = ({
	gradient = "--gradient-sunset",
	borderWidth = "2px",
	borderStyle = "solid",
	width,
	height,
	selected = true,
	children = <></>,
	wrapperClassNames = "",
	buttonClassNames = "",
	value,
	alignment = "center",
	loading = false,
	buttonProps = {},
	fullBackgroundGradient = false,
	adminButton,
	color,
	asLink,
	linkProps = { to: "" },
	opacity,
	hoverOpacity,
	margin,
	inline,
	wrapperProps = {},
	defaultBackground = 'var(--gray-800)',
	unselectedHoverBackground,
}: IGradientButtonProps) => {
	const { disabled, ...restButtonProps } = buttonProps;

	return (
		<div
			className={
				classNames(
					"gradient-button-wrapper",
					`align-${alignment}`,
					{
						selected,
						disabled,
						adminButton,
					},
					wrapperClassNames,
				)
			}
			style={{
				padding: borderWidth,
				...(selected ? {
					border: `${borderWidth} ${borderStyle} var(${gradient})`,
					background: `var(${gradient})`,
				} : {
					'--gradient-btn-default-background': defaultBackground,
				}),
				...(width ? { width } : {}),
				...(height ? { height } : {}),
				...(inline ? { display: 'inline-flex' } : {}),
				...(margin || margin === 0 ? { margin } : {}),
				...(opacity || opacity === 0 ? { '--gradient-button-opacity': opacity } : {}),
				...(hoverOpacity || hoverOpacity === 0 ? { '--gradient-button-hover-opacity': hoverOpacity } : {}),
				...(unselectedHoverBackground ? { '--gradient-btn-unselected-hover-background': unselectedHoverBackground } : {}),
			}}
			{...wrapperProps}
		>
			{asLink ? (
				<Link
					className={classNames(
						"no-style clear",
						buttonClassNames,
						{
							'full-background-gradient': fullBackgroundGradient
						}
					)}
					style={{
						...(color ? { color } : {}),
					}}
					{...linkProps}
				><div className="gradient-link-content-wrapper">{children}</div></Link>
			) : (
				<button
					className={classNames(
						"no-style clear",
						buttonClassNames,
						{
							'full-background-gradient': fullBackgroundGradient
						}
					)}
					value={value}
					disabled={disabled}
					style={{
						...(color ? { color } : {}),
					}}
					{...restButtonProps}
				>
					<>
						{children}
						{loading ? (
							<div
								className="gradient-button-loading-overlay"
							><WaitingIndicator /></div>
						) : null}
					</>
				</button>
			)}
		</div>
	);
};

export default GradientButton;
